import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/lib/i18n";
import { blogContent } from "./content";

/**
 * "The 3 criteria" section of the 2026 comparison article.
 * Links each criterion to its dedicated feature page and points to the
 * full buying guide, matching the article's serif editorial style.
 */
export function CriteriaSection() {
  const { language } = useLanguage();
  const c = blogContent[language].criteria;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 pb-16">
      <h2 className="font-['Source_Serif_4'] text-[1.75rem] sm:text-[2rem] leading-tight font-semibold text-foreground mt-4 mb-5">
        {c.title}
      </h2>

      <p className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85 mb-8">
        {c.intro}
      </p>

      <div className="space-y-6 mb-10">
        {c.items.map((item, i) => (
          <div
            key={i}
            className="rounded-2xl border border-border/40 bg-card p-6 shadow-sm"
          >
            <h3 className="font-['Source_Serif_4'] text-xl font-semibold text-foreground mb-2">
              {item.title}
            </h3>
            <p className="text-base leading-relaxed text-muted-foreground mb-4">
              {item.text}
            </p>
            <Link
              to={item.href}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:gap-2.5 transition-all duration-200"
            >
              {item.linkLabel}
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        ))}
      </div>

      <p className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85">
        {c.guideText}{" "}
        <Link
          to={c.guideHref}
          className="text-primary underline underline-offset-4 decoration-primary/40 hover:decoration-primary transition-colors font-semibold"
        >
          {c.guideLabel}
        </Link>
      </p>
    </section>
  );
}
